<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">
    <div class="p-24 pb-4">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newVoucherTemplate()"
                aria-label="New voucher"
                *appIsGranted="['Voucher templates', 'CREATE']"
            >
            {{'New voucher'|translate}}
        </button>
    </div>
    <div class="p-24 pt-4">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newVoucherTemplateGroup()"
                aria-label="New group"
                *appIsGranted="['Voucher templates', 'CREATE']"
        >
            {{'New group'|translate}}
        </button>
    </div>

    <div class="nav material2" *appIsGranted="['Voucher templates', 'READ']">
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/settings/voucher-templates'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_shipping</mat-icon>
                <span>{{'Active templates'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/settings/voucher-template-groups'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_shipping</mat-icon>
                <span>{{'Voucher groups'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/settings/voucher-templates/sorting'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_shipping</mat-icon>
                <span>{{'Sorting'|translate}}</span>
            </a>
        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
